export default "\r\n<h1 *ngIf=\"user\">{{user?.username}}</h1>\r\n\r\n<p *ngIf=\"!user\">\r\n    user not found.\r\n</p>\r\n\r\n\r\n"